import { takeEvery, put, call} from "redux-saga/effects"
import {GET_VERIFICATION_DOCUMENT_LIST, GET_VERIFICATION_DOCUMENT_VIEW_DETAILS} from './actionType'
import {getInterviewCandidateList} from "../../../../helpers/fakebackend_helper"
import {  getDocumentListDataSuccess , getDocumentListDataFail, getviewDocumentListDataSuccess, getviewDocumentListDataFail} from './actions'

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

function* getDocmentListDataHandler({payload: {json}}){
  let url = constClass.REST_API_DOCUMENTS_DATA+`?page=${json.pageNumber}&pageSize=${json.pageSize}`
   let extentedUrl= ""
  if(json.sort !== undefined && json.Sort !== null){
       url = url+json.sort
  }
  if(json.keyword !== undefined && json.keyword  !== null && json.keyword  !== "" ){
    url = url+json.keyword
}
if(json.filter !== undefined && json.filter !== null && json.filter !== "" && json.filter.length > 0){
   json.filter.map(eachObject=>{extentedUrl +=  encodeURIComponent(eachObject.filterName)+"="+encodeURIComponent(`${[eachObject.value]}`)+"&"    
  }
  )
  extentedUrl = extentedUrl.slice(0, extentedUrl.length-1)

}
  try {
    if(extentedUrl !== ""){
     url =  url+"&"+extentedUrl
    }
    let response = yield call(getInterviewCandidateList, url);
    yield put(getDocumentListDataSuccess(response))
  }

  catch (error) {
    yield put(getDocumentListDataFail(error))
  }
}


function * getDocViewDetailsHandler(){
  try{
    let url = constClass.REST_API_DOCUMENTS_DATA
    let response = yield call(getInterviewCandidateList, url);
    yield put(getviewDocumentListDataSuccess(response))
  }
  catch (error) {
    yield put(getviewDocumentListDataFail(error))
  }
}






function* verificationDocSaga() {
  yield takeEvery( GET_VERIFICATION_DOCUMENT_LIST, getDocmentListDataHandler)
  yield takeEvery(GET_VERIFICATION_DOCUMENT_VIEW_DETAILS, getDocViewDetailsHandler)
}
export default verificationDocSaga

